<template>
	<div>
		<div class="clearfix headerTag">
			<a class="fl arror" href="javascript:history.go(-1)" >返回</a>
			<div style="width: 8.46rem;">
				<span  :class="[{ headTit: resultFull }]" style="margin-left:0.7rem">购车计算器</span>
				<div  class="fr" >发送到手机</div>
			</div>
		</div>
		<div  class="tabView">
		  <!--<div :class="[{ tabColor: isActiveLeft }, 'tabLeft','tabPos']">
			  全款
		  </div>
		  <div class="verticalLine"></div>
		  <div  :class="[{ tabColor: isActiveRight }, 'tabRight','tabPos']">
			  贷款
		  </div>-->
		  <div class="flexbox">
			  <div :class="['tabLeft','tabPos',{ tabColor: isActiveLeft }]">
				  全款
			  </div>
			  <div :class="[{colorLine: isActiveLeft}]"></div>
		  </div>
		  <div class="verticalLine"></div>
		  <div class="flexbox">
			  <div  :class="['tabRight','tabPos',{ tabColor: isActiveRight }]">
				  贷款
			  </div>
			  <div :class="[{colorLine: isActiveRight}]"></div>
		  </div>
		</div>
		<div  v-show="bodyIsShow">
			<div  class="bigbodywrap">
				<section id="formwrapSection" class="formwrapSection clearfix bac">
					<div class="formwrap">
						<form id="signUpfrom" class="signUpfrom" action="/hmtcj/applyForTcj" method="post"  style="background: #fff;">
							<div  :class="['sinformTotalPriceLoad',{heightInfo:!showLoadContent}]" >
								<div  class="sinformTotalPriceLeft">
									<div  class="sinformTit"  v-if="showLoadContent">贷款总价（元）</div>
									<div  class="sinformTit" v-else>全款总价（元）</div>
									<div  class="sinformTotalPri">{{showData.totalPrice}}</div>
								</div>
								<div class="sinformDetails" v-if="showLoadContent">
										<div>
											<p>首付（元）</p>
											<p class="bigsize">{{showData.downPayment}}</p>
										</div>
										<div>
											<p>参考月供（元）</p>
											<p class="bigsize">{{showData.payMonthly}}</p>
										</div>
										<div>
											<p>贷款额度（元）</p>
											<p class="bigsize">{{showData.loanLimit}}</p>
										</div>
										<div>
											<p>利息（元）</p>
											<p class="bigsize">{{showData.interest}}</p>
										</div>
								</div>
							</div>
							<div class="sinform" style="margin-top: 0.1rem;">
	                            <em class="fontColorTit" style="margin-right: 0.6rem;">选择车款</em>
	                            <div class="sinform-text fontColorVal" id="insertCarinfo" >{{carAllName}}</div>
	                        </div>
	                        <div class="sinformBotLine"></div>
			                <div class="sinform">
			                    <em class="fontColorTit">裸车价格</em>
			                    <input type="text" style="margin-right: 0.1rem;" readonly="readonly" :value="showData.carPrice" class="sinform-text fontColorVal" name="usernane" placeholder="裸车价格" maxlength="10" id="usernane" >
			                    <em style="margin-left: 0.1rem;">元</em>
			                </div>
			                <div class="sinformBotLine"></div>
			                <div>
				                <div class="sinform" v-show="showData.downPaymentRatio!=100">
		                            <em class="fontColorTit" style="margin-right: 0.6rem;">首付比例</em>
		                            <div  class="sinform-text" id="selectCarPay" style="color: #333;">{{showData.downPaymentRatio}}%</div>
		                        </div>
		                        <div class="sinformBotLine"  v-show="showData.downPaymentRatio!=100"></div>
		                        <div class="sinform" v-show="showData.loanTerm!=0">
		                            <em class="fontColorTit" style="margin-right: 0.6rem;">还款年限</em>
		                            <div  class="sinform-text" id="selectCarYear" style="color: #333;">{{showData.loanTerm/12}}年</div>
		                            <input type="text" hidden="hidden" id="loanTermId"/>
		                        </div>
		                        <div class="sinformBotLine"  v-show="showData.loanTerm!=0"></div>
			                </div>
			                <div class="sinform">
			                    <em class="fontColorTit">必要花费</em>
			                    <input type="text" style="margin-right: 0.1rem;" readonly="readonly" :value="showData.necPrice" class="sinform-text fontColorVal" name="usernane" placeholder="必要花费" maxlength="10" id="usernane" >
			                    <em style="margin-left: 0.1rem;">元</em>
			                </div>
			                <div class="sinform" style="height: 1rem;line-height: 1rem;display: flex;justify-content: space-between;">
			                	<em  class="sinform-open-left">购置税、交强险等</em>
			                	<em  class="sinform-open-right" v-text="isTakeupCon?'收起 -':'展开详细 +'"></em>
			                </div>
			                <div v-show="isTakeupCon">
			                	<div class="sinform">
				                    <em style="margin-right: 0.6rem;" class="fontColorTit">购置税</em>
				                    <input type="text" readonly="readonly" :value="showData.vehiclePurchaseTaxes" class="sinform-text fontColorVal" name="usernane" placeholder="购置税" maxlength="10" id="usernane" >
				                </div>
				                <div class="sinform">
		                            <em  style="margin-right: 0.6rem;" class="fontColorTit">交强险</em>
		                            <div  class="sinform-text fontColorVal" id="selectCarInsu" >{{showData.sali}}</div>
		                            <input type="text" hidden="hidden"  id="selectCarInsuId"/>
		                        </div>
		                        <div class="sinform">
		                            <em class="fontColorTit" style="margin-right: 0.6rem;">车船使用税</em>
		                            <div  class="sinform-text sinform-text2 fontColorVal" id="selectCarTax" >{{showData.vehicleVesselTax}}</div>
		                            <input type="text" hidden="hidden" id="selectCarTaxId"/>
		                        </div>
		                        <div class="sinform">
				                    <em style="margin-right: 0.6rem;" class="fontColorTit">上牌费用</em>
				                    <input type="text" readonly="readonly" :value="showData.regPrice" class="sinform-text fontColorVal" name="usernane" placeholder="上牌费用" maxlength="10" id="usernane" >
				                </div>
			                </div>
						</form>
						<div class="sinformReference"  v-show="showLoadContent">
		                	<p>1、此结果仅供参考，实际应缴费用以当地为准</p>
		                	<p>2、分期方案利率参考：1年期4.85%；2年期5.25%；</p>
		                	<p>3年期5.25%；4年期5.25%；5年期5.25%。具体分期</p>
		                	<p>金融方案供参考，以合作的金融机构为准</p>
		                </div>
		                <div v-show="!showLoadContent" style="margin-bottom:1em;color: #bdbdbd;" class="addxyroom posLocation" >*此结果仅供参考，实际应缴费用以当地为准</div>
					</div>
				</section>
			</div>
		</div>
		<setBtnComponent></setBtnComponent>
	</div>
</template>
<script>
export default {
	name: 'fullSection',
//	props: ["result"],	//prop传值
	data:function() {
		return {
			bodyIsShow:false,
			isTakeupCon:true,
			isActiveLeft:true,
			showLoadContent:false,
     		isActiveRight:false,
     		shareInfo: {
				maintitle: '',
				shareUrl: '',
				imgUrl:'',
				remark:''
			},
			showData:{
			},
            carAllName:'请选择车款'
		}
	},
//	computed: {
//	    // 计算属性的 getter
//	    prices: function () {
//	      // `this` 指向 vm 实例
//	      if(self.buyTypes==0){
//				//全款总价
//				return parseFloat(self.carPrices)+self.vehiclePurchaseTaxeses+self.salis+self.vehicleVesselTaxs+self.regPrices;
//			}else{
//				//全款总价
//				return self.downPayments+self.interests+self.loanLimits;
//			}
//	    }
//	    
//	 },
	mounted:function(){
		var self = this;
		getCommonJsIns.initCSSNEW();
		getCommonJsIns.initSingleCSSNEW({
			cssURL: "/css/mapply/calculator/index.css?v=123"
		});
		
		//确保重要依赖的js加载完成
		getCommonJsIns.initJSNEW(this.webReady);
	},
	methods:{
		webReady:function(){
			var self =this;
			self.bodyIsShow=true;
			self.subApply();
			
		},
		shareWeb: function() {
			var self = this;
			var mainTitle = "";
			var remark = "";
			var shareImgHeader= "https://" + window.location.host + "/static/img/nubIcon.png?v=1";
			self.shareInfo.mainTitle='我正在使用团车购车计算器，一键计算最终购车总价，你也来试试吧！';
			self.shareInfo.shareUrl= window.location.href;
			self.shareInfo.remark='我正在使用团车购车计算器，一键计算最终购车总价，你也来试试吧！';
			webCommonUtil.wechatShare.init({
				weChatShareInfo: {
					code: 200,
					result: {
						mainTitle: self.shareInfo.mainTitle,
	
						shareUrl: self.shareInfo.shareUrl,
	
						remark: self.shareInfo.remark,
	
						imgUrl: shareImgHeader
	
					},
					callback: function() {
					}
				}
			}, wx)
			console.log(self.shareInfo.shareUrl+'2222');
	  		console.log(self.shareInfo.mainTitle+'2222');
	  		console.log(shareImgHeader+'2222');
	  		console.log(self.shareInfo.remark+'2222');
		},
		toMoney:function(num) {
			var self=this;
			num = parseFloat(num).toString().split(".");
			num[0] = num[0].replace(new RegExp('(\\d)(?=(\\d{3})+$)', 'ig'), "$1,");
			return num.join(".");
		},
		subApply:function(){
			var self = this;
			self.ajaxSubmit.ajax({
//				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.applyForTcjAsyn,
				url:self.commmonWebConfig.tuancheapi+self.ajaxSubmit.allUrl.calcultorShare,
				type:"post",
				data:{
					'id':self.$route.query.id
				},
//				contentType: 'application/json;charset=UTF-8',
				success:function(data){
					if(data.responseHeader.status == 200){
						self.showData=data.response.result;
						self.carAllName=self.showData.styleSeriesName+'-'+self.showData.styleName+'-'+self.showData.brandName;
						self.showData.totalPrice=self.toMoney(data.response.result.totalPrice);
						self.showData.downPayment=self.toMoney(data.response.result.downPayment);
						self.showData.payMonthly=self.toMoney(data.response.result.payMonthly);
						self.showData.loanLimit=self.toMoney(data.response.result.loanLimit);
						self.showData.interest=self.toMoney(data.response.result.interest);
						self.showData.carPrice=self.toMoney(data.response.result.carPrice);
						self.showData.necPrice=self.toMoney(data.response.result.necPrice);
						self.showData.vehiclePurchaseTaxes=self.toMoney(data.response.result.vehiclePurchaseTaxes);
						self.showData.sali=self.toMoney(data.response.result.sali);
						self.showData.vehicleVesselTax=self.toMoney(data.response.result.vehicleVesselTax);
						self.showData.regPrice=self.toMoney(data.response.result.regPrice);
						if(self.carAllName=="--"){
							self.carAllName='请选择车款';
						}else{
							self.carAllName=self.showData.styleSeriesName+'-'+self.showData.styleName+'-'+self.showData.brandName;
						}
						if(self.showData.buyType==0){
							self.isActiveLeft=true;
							self.isActiveRight=false;
						}else{
							self.isActiveLeft=false;
							self.isActiveRight=true;
						}
						self.shareWeb();
						if(self.showData.buyType==0){
							self.showLoadContent=false;
//							self.isTakeupCon=false;
						}else{
							self.showLoadContent=true;
//							self.isTakeupCon=true;
							
						}
						
					}
					
				},
				error:function(){
					Toast({
	                  message: "系统忙，请稍后",
	                  position: 'middle',
	                  duration: 2000
	                });
				}
			});
		},
	},
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/calculator/calcuShare.vue